// extracted by mini-css-extract-plugin
export default {"fileBox":"MarketRequestForm_fileBox__ZEgRJ","fileBoxTitle":"MarketRequestForm_fileBoxTitle__TPT4L"};